import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");

export const getDetailEntete = createAsyncThunk("importFacture/getDetailEntete", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "importFacture/getDetailEntete", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const importFacture = await response.json();
  return importFacture;
});
export const getImportFactureDate = createAsyncThunk("importFacture/getImportFactureDate", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "importFacture/getImportFactureDate", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const importFacture = await response.json();
  return importFacture;
});


export const fetchImportFacture = createAsyncThunk("importFacture/fetchImportFacture", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "importFacture/allImportFacture", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const importFacture = await response.json();
  return importFacture;
});


export const importFactureAdded = createAsyncThunk("importFacture/addImportFacture", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "importFacture/addImportFacture", {
   method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });

  const importFacture = await response.json();
  return importFacture;
});

export const importFactureDeleted = createAsyncThunk("importFacture/delete", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "importFacture/delete/" + id, {
    method: "delete",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const importFacture = await response.json();
  return importFacture;
});



export const importFactureGetById = createAsyncThunk("importFacture/importFactureGetById", async (id1) => {
  const id = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "importFacture/getImportFacture", {
    method: 'POST',
    headers: {
      'id': id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const importFacture = await response.json();
  return importFacture;
});

const importFactureReduce = createSlice({
  name: "importFacture",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {



  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchImportFacture.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchImportFacture.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, ...action.payload];
      })
      .addCase(fetchImportFacture.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(importFactureGetById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(importFactureGetById.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, action.payload];
      })
      .addCase(importFactureGetById.rejected, (state, action) => {
        state.loading = false;
      });
  },

});
export default importFactureReduce.reducer;
